<!--Translated-->
<template>
  <tbody :class="`tbl-color--${category.class}`">
    <template v-for="(item, index) in displayItems">
      <tr
        class="row tbl_row--active"
        v-if="item.type === 'product'"
        :key="item.data.id"
      >
        <td
          v-if="index === 0"
          class="tbl-cellproblem"
          :rowspan="totalRowsCount"
        >
          <div class="cellproblem-inner">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: category.icon }"></div>
                <HoverTooltip
                  :images="images"
                  :header="pest.name"
                  :text="pest.description"
                  :link="pest.link"
                />
              </div>
              <div class="tbl_info-celltext">{{ pest.name }}</div>
            </div>

            <!--#STAS #2026 Button add combination-->
            <Button
              v-if="products.length >= 2 && canEdit"
              :text="$t('DefenseCombinations:Button')"
              size="h-micro"
              color="accentlines"
              icon="plus"
              @click="addMockCombination"
            />
          </div>
        </td>
        <td
          class="tbl-cellproduct"
          colspan="3"
          :class="{
            'tbl-cellproduct--grey': !pestsProductsAsMap[item.data.id],
          }"
        >
          <div class="tbl_info">
            <div class="tbl_info-wrap">
              <div
                v-if="item.data.is_active"
                v-svg="{ name: 'info' }"
                :key="'active'"
              />
              <div
                v-else
                v-svg="{ name: 'warningtriangle' }"
                :key="'no_active'"
                id="force-red"
              />
              <HoverTooltipProduct :product="item.data" />
            </div>
            <div class="tbl_info-celltext">{{ item.data.name }}</div>
          </div>
        </td>
        <td class="tbl-cellinpt">
          <InputNumber
            class="inputintable"
            type="number"
            label="-"
            :value="pestsProductsAsMap[item.data.id]"
            @input="onInput(item.data, $event)"
            :state="isSaving ? 'disabled' : readonly ? 'disabled2' : ''"
          />
        </td>
        <td class="tbl-cellprice">
          {{
            item.data.picking
              ? (
                  (item.data.price / item.data.picking) *
                  pestsProductsAsMap[item.data.id]
                ).toFixed(2)
              : '0.00'
          }}
        </td>
      </tr>

      <template v-else-if="item.type === 'combination'">
        <!-- Технический отступ перед комбинацией (кроме первой строки) -->
        <tr
          v-if="index > 0"
          class="row row--combination-spacer"
          :key="'combo-spacer-' + item.id"
        >
          <td colspan="5"></td>
        </tr>

        <!-- Шапка комбинации -->
        <tr
          class="row tbl_row--active row--combination"
          :key="'combo-header-' + item.id"
        >
          <th
            v-if="index === 0"
            class="tbl-cellproblem"
            :rowspan="totalRowsCount"
          >
            <div class="cellproblem-inner">
              <div class="tbl_info">
                <div class="tbl_info-wrap">
                  <div v-svg="{ name: category.icon }"></div>
                  <HoverTooltip
                    :images="images"
                    :header="pest.name"
                    :text="pest.description"
                    :link="pest.link"
                  />
                </div>
                <div class="tbl_info-celltext">{{ pest.name }}</div>
              </div>

              <!--#STAS #2026 Button add combination-->
              <Button
                v-if="products.length >= 2 && canEdit"
                :text="$t('DefenseCombinations:Button')"
                size="h-micro"
                color="accentlines"
                icon="plus"
                @click="addMockCombination"
              />
            </div>
          </th>
          <!-- Иконка пазла — та же колонка что col-add (плюс) под ней -->
          <th class="combination-header-cell" colspan="4">
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div v-svg="{ name: 'combinationpuzzle' }"></div>
                <AppInput
                  :value="item.comment"
                  @input="updateComboComment(item.id, $event)"
                  class="inputintable inputintable--comment"
                  type="text"
                  :placeholder="$t('DefenseCombinations:CommentPlaceholder')"
                />
              </div>
            </div>
          </th>
          <!-- Удалить комбинацию — та же колонка что tbl-cellprice -->
          <th
            class="col-delete col-delete--btn unicol-colordark"
            @click="removeMockCombination(item.id)"
          >
            <div v-svg="{ name: 'delete' }"></div>
          </th>
        </tr>

        <!-- Строки продуктов комбинации -->
        <tr
          v-for="(comboProd, cIdx) in item.products"
          :key="'combo-prod-' + comboProd._comboProductId"
          class="row tbl_row--active row--combination"
        >
          <!-- Кнопка добавить продукт (rowspan на все продукты комбинации) -->
          <td
            v-if="cIdx === 0"
            class="col-add"
            :rowspan="item.products.length"
            @click="openComboAddModal(item.id)"
          >
            <div v-svg="{ name: 'plus2' }"></div>
          </td>
          <!-- Название продукта + inline кнопка удаления продукта из комбинации -->
          <td
            class="tbl-cellproduct"
            :class="{ 'tbl-cellproduct--grey': !comboProd.quantity }"
          >
            <div class="tbl_info">
              <div class="tbl_info-wrap">
                <div
                  v-if="comboProd.is_active"
                  v-svg="{ name: 'info' }"
                  :key="'active'"
                />
                <div
                  v-else
                  v-svg="{ name: 'warningtriangle' }"
                  :key="'no_active'"
                  id="force-red"
                />
                <HoverTooltipProduct :product="comboProd" />
              </div>
              <div class="tbl_info-celltext">{{ comboProd.name }}</div>
            </div>
          </td>

          <td
            class="col-delete"
            @click="removeComboProduct(item.id, comboProd._comboProductId)"
            style="cursor: pointer"
          >
            <div v-svg="{ name: 'delete' }"></div>
          </td>
          <td class="tbl-cellinpt">
            <InputNumber
              class="inputintable"
              type="number"
              label="-"
              :value="comboProd.quantity"
              @input="
                updateComboProductQuantity(comboProd._comboProductId, $event)
              "
            />
          </td>
          <td class="tbl-cellprice">
            {{
              comboProd.picking && comboProd.quantity
                ? (
                    (comboProd.price / comboProd.picking) *
                    comboProd.quantity
                  ).toFixed(2)
                : '0.00'
            }}
          </td>
        </tr>
        <!-- Если товаров в комбинации нет -->
        <tr
          v-if="item.products.length === 0"
          class="row tbl_row--active"
          :key="'combo-empty-' + item.id"
        >
          <td
            class="col-add combination-col-add"
            @click="openComboAddModal(item.id)"
          >
            <div v-svg="{ name: 'plus2' }"></div>
          </td>
          <td
            class="tbl-cellproduct"
            colspan="4"
            style="text-align: center; color: #999"
          >
            {{ $t('DefenseCombinations:MinProducts') }}
          </td>
        </tr>
      </template>
    </template>

    <tr
      v-if="products.length === 0 && combinations.length === 0"
      class="row tbl_row--active"
    >
      <td class="tbl-cellproblem" rowspan="1">
        <div class="tbl_info">
          <div class="tbl_info-wrap">
            <div v-svg="{ name: category.icon }"></div>
            <HoverTooltip
              :images="images"
              :header="pest.name"
              :text="pest.description"
              :link="pest.link"
            />
          </div>
          <div class="tbl_info-celltext">{{ pest.name }}</div>
        </div>
      </td>
      <td class="tbl-cellproduct" colspan="5" style="text-align: center">
        {{ $t('TemplateRowPest:NoProducts') }}
      </td>
    </tr>

    <tr class="tablelinedecor">
      <td colspan="6"></td>
    </tr>

    <DefenseAddProductModal
      v-if="showAddModal"
      :productsList="availableProductsToAdd"
      :alreadyAdded="alreadyAddedProductsIds"
      @save="addProduct"
      @close="
        showAddModal = false;
        activeCombinationId = null;
      "
    />
  </tbody>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { mutationTypes } from '@/store/modules/plantsCare';
import InputNumber from '@/components/views/wrappers/InputNumberWithCast';
import Button from '@/components/views/Button';
import HoverTooltip from './HoverTooltip';
import HoverTooltipProduct from './HoverTooltipProduct';
import { mapPestCategoryToProductCategory } from './mapCategoryToPest';
import DefenseAddProductModal from './DefenseAddProductModal';
import AppInput from '@/components/views/Input.vue';

export default {
  name: 'TemplateRowPest',
  components: {
    AppInput,
    InputNumber,
    HoverTooltip,
    HoverTooltipProduct,
    Button,
    DefenseAddProductModal,
  },
  props: {
    phase: { type: Object, required: true },
    pest: { type: Object, required: true },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      showAddModal: false,
      activeCombinationId: null,
    };
  },
  computed: {
    ...mapGetters(['plantsCareProductsAsMap', 'plantsCarePestsProductsAsMap']),
    ...mapState({
      canEdit: (state) =>
        state.auth.currentUserRole?.claim_plants_care_add === 1,
      isSaving: (state) => state.plantsCare.isSaving,
      waterQuantity(state) {
        return (
          state.plantsCare.templateWaterPhases.find(
            (p) => p.phase_id === this.phase.id
          )?.quantity ?? 0
        );
      },
      productsPestsSubcategories: (state) =>
        state.products.productsPestsSubcategories,
      category(state) {
        return state.products.productsPestsSubcategories.find(
          ({ id }) =>
            id === mapPestCategoryToProductCategory(this.pest.category_id)
        );
      },
      products(state) {
        return (
          state.plantsCare.productsPests
            .filter(({ pest_id }) => pest_id === this.pest.id)
            // .filter((product) => product.is_active)
            .map(({ product_id }) => this.plantsCareProductsAsMap[product_id])
            .filter(Boolean)
            .filter(
              (product) =>
                product.is_active ||
                state.plantsCare.templatePestsProducts.some(
                  ({ product_id }) => product_id === product.id
                )
            )
        );
      },
      images(state) {
        const cultureId = state.plantsCare.template.culture_id;
        const hasImagesBindedToCulture = state.plantsCare.images.some(
          (img) => img.meta_id === cultureId
        );

        return state.plantsCare.images
          .filter(
            (img) =>
              img.object_id === this.pest.id &&
              img.type === 0 &&
              (hasImagesBindedToCulture ? cultureId === img.meta_id : true)
          )
          .sort((a, b) => a.meta_id - b.meta_id);
      },
    }),
    combinations() {
      const combos =
        this.$store.state.plantsCare.templatePestsCombinations.filter(
          (c) => c.phase_id === this.phase.id && c.pest_id === this.pest.id
        );
      const comboProducts =
        this.$store.state.plantsCare.templatePestsCombinationsProducts;
      return combos.map((c) => ({
        type: 'combination',
        id: c.id,
        comment: c.comment,
        products: comboProducts
          .filter((p) => p.combination_id === c.id)
          .map((p) => ({
            ...p,
            ...(this.plantsCareProductsAsMap[p.product_id] || {}),
            _comboProductId: p.id,
          })),
      }));
    },
    displayItems() {
      const items = [];
      this.products.forEach((p) => {
        items.push({ type: 'product', data: p });
      });
      this.combinations.forEach((combo) => {
        items.push(combo);
      });
      return items;
    },
    totalRowsCount() {
      return (
        this.displayItems.reduce((acc, item, index) => {
          if (item.type === 'combination') {
            const rowsForProducts =
              item.products.length > 0 ? item.products.length : 1;
            const spacerRow = index > 0 ? 1 : 0;
            return acc + spacerRow + 1 + rowsForProducts;
          }
          return acc + 1;
        }, 0) || 1
      );
    },
    pestsProductsAsMap() {
      const getValueById = (id) =>
        this.plantsCarePestsProductsAsMap[
          `phase_${this.phase.id}_pest_${this.pest.id}_product_${id}`
        ]?.quantity ?? '';
      return Object.fromEntries(
        this.products.map((p) => [p.id, getValueById(p.id)])
      );
    },
    alreadyAddedProductsIds() {
      if (this.activeCombinationId) {
        const combo = this.combinations.find(
          (c) => c.id === this.activeCombinationId
        );
        return combo ? combo.products.map((p) => p.product_id) : [];
      }
      return [];
    },
    availableProductsToAdd() {
      // Пользователь сказал: "В этом дропдауне должен быть этот же список [что и в таблице]".
      // this.products уже содержит нужный отфильтрованный список препаратов для данного вредителя.
      return this.products;
    },
  },
  methods: {
    confirmDelete(message, next) {
      this.$confirm({
        message,
        buttons: {
          left: {
            text: this.$t('DefenseCombinations:ConfirmDelete'),
            icon: 'delete',
          },
          right: {
            text: this.$t('DefenseCombinations:ConfirmCancel'),
            icon: 'cancel',
          },
        },
        callback: (confirm) => {
          if (confirm) next();
        },
      });
    },
    openComboAddModal(id) {
      this.activeCombinationId = id;
      this.showAddModal = true;
    },
    removeComboProduct(comboId, comboProductId) {
      const combo = this.combinations.find((c) => c.id === comboId);
      const comboProduct = combo?.products.find(
        (p) => p._comboProductId === comboProductId
      );
      const doRemove = () =>
        this.$store.commit(mutationTypes.removePestCombinationProduct, {
          id: comboProductId,
        });

      if ((comboProduct?.quantity ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteProduct'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    addMockCombination() {
      this.$store.commit(mutationTypes.addPestCombination, {
        phase_id: this.phase.id,
        pest_id: this.pest.id,
      });
    },
    removeMockCombination(id) {
      const combo = this.combinations.find((c) => c.id === id);
      const doRemove = () =>
        this.$store.commit(mutationTypes.removePestCombination, { id });

      if ((combo?.products?.length ?? 0) > 0) {
        this.confirmDelete(
          this.$t('DefenseCombinations:ConfirmDeleteCombination'),
          doRemove
        );
        return;
      }

      doRemove();
    },
    addProduct(productId) {
      if (this.activeCombinationId) {
        this.$store.commit(mutationTypes.addPestCombinationProduct, {
          combination_id: this.activeCombinationId,
          product_id: productId,
        });
        this.activeCombinationId = null;
      } else {
        this.$store.commit(mutationTypes.upsertPestProduct, {
          phase_id: this.phase.id,
          pest_id: this.pest.id,
          product_id: productId,
          quantity: 0,
        });
      }
    },
    onInput(product, value) {
      this.$store.commit(mutationTypes.upsertPestProduct, {
        phase_id: this.phase.id,
        pest_id: this.pest.id,
        product_id: product.id,
        quantity: value,
      });
    },
    updateComboComment(id, comment) {
      this.$store.commit(mutationTypes.updatePestCombinationComment, {
        id,
        comment,
      });
    },
    updateComboProductQuantity(id, quantity) {
      this.$store.commit(mutationTypes.upsertPestCombinationProductQuantity, {
        id,
        quantity,
      });
    },
  },
};
</script>

<style lang="scss">
@import '~@/scss/vars.scss';

.tbl-cellproduct--grey {
  & .tbl_info-celltext {
    color: $colorGray !important;
  }
  & svg * {
    fill: $colorGray !important;
  }
}
#force-red path,
#force-red:hover path {
  fill: #a93239 !important;
}

/* ===== Комбинация ===== */

// FOR SUBTABLE
.table--defense {
  .col-delete {
    width: $heightStandart;
    max-width: $heightStandart;
  }

  .col-add {
    cursor: pointer;
    width: $heightStandart;
    max-width: $heightStandart;
    padding: 0;
    text-align: center;

    & > div {
      height: 100%;
      display: flex;
      align-items: center;
    }
  }

  .row--combination-spacer {
    height: $marginMicro;
    padding: 0;
    border: none;
  }

  .combination-header-cell {
    padding-left: 0;

    label {
      display: none;
    }

    .tbl_info {
      width: 100%;
    }

    .tbl_info-wrap {
      width: 100%;
      display: flex;
      align-items: flex-start;

      & > div:first-child {
        width: $heightStandart !important;
        max-width: $heightStandart !important;
        min-width: $heightStandart !important;
        //background-color: black;
        display: flex;
        margin-right: 0 !important;
        //justify-content: flex-end;

        & svg {
          width: 100%;
          height: 100%;
        }
      }
      .inputintable {
        flex-grow: 1 !important;
        width: 100% !important;
        margin-left: 0px !important;
        padding: 0 !important;
        padding: $marginNano2;
        box-sizing: border-box;
        width: auto;
        min-width: auto;

        .inptline {
          width: 100% !important;
        }

        .inptline_inputzone {
          width: 100% !important;
        }

        input {
          width: 100% !important;
          max-width: none !important;
          //height: 32px !important;
          height: 46px;

          font-size: $fontsizeStandart;
          line-height: $lineFontsizeStandart;

          border-radius: $borderRadiusMicro;
          color: $colorAccent;
        }
      }
    }
  }

  .row--combination th {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
}

@media screen and (max-width: 1800px) {
  // FOR SUBTABLE
  .table--defense {
    .col-delete {
      width: $heightStandart-k1600;
      max-width: $heightStandart-k1600;
    }

    .col-add {
      cursor: pointer;
      width: $heightStandart-k1600;
      max-width: $heightStandart-k1600;
      padding: 0;
      text-align: center;
    }

    .row--combination-spacer {
      height: $marginMicro-k1600;
    }

    .combination-header-cell {
      .tbl_info-wrap {
        & > div:first-child {
          width: $heightStandart-k1600 !important;
          max-width: $heightStandart-k1600 !important;
          min-width: $heightStandart-k1600 !important;
        }
        .inputintable {
          padding: $marginNano2-k1600;

          input {
            height: 46px;
            font-size: $fontsizeStandart-k1600;
            line-height: $lineFontsizeStandart-k1600;
            border-radius: $borderRadiusMicro-k1600;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1420px) {
  // FOR SUBTABLE
  .table--defense {
    .col-delete {
      width: $heightStandart-k1360 !important;
      max-width: $heightStandart-k1360 !important;
    }

    .col-add {
      cursor: pointer;
      width: $heightStandart-k1360;
      max-width: $heightStandart-k1360;
      padding: 0;
      text-align: center;
    }

    .row--combination-spacer {
      height: $marginMicro-k1360;
    }

    .combination-header-cell {
      .tbl_info-wrap {
        & > div:first-child {
          width: $heightStandart-k1360 !important;
          max-width: $heightStandart-k1360 !important;
          min-width: $heightStandart-k1360 !important;
        }
        .inputintable {
          padding: $marginNano2-k1360;

          input {
            height: 30px;
            font-size: $fontsizeStandart-k1360;
            line-height: $lineFontsizeStandart-k1360;
            border-radius: $borderRadiusMicro-k1360;
          }
        }
      }
    }
  }
}

/* Кнопка удаления комбинации (тёмно-серая ячейка справа) */
.col-delete--btn {
  cursor: pointer;

  &:hover {
    background-color: $colorError; //#7a7d80;// !important;
  }
}
</style>
